const isPWA = () => {
   const isUsingPwa = window.matchMedia("(display-mode: standalone)").matches || false;
   return isUsingPwa;
};

export default isPWA;
